module.exports = __webpack_public_path__ + "2cef8768edb0e22312c1a4d2629db6c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/pages/list-bg.png
// module id = 129
// module chunks = 75